import { Vertical, Horizontal, Texto } from '@gravitate-js/excalibrr'
import { IconRefreshAlert, IconUsers } from '@tabler/icons-react'
import { Tooltip, Tag, Popover } from 'antd'

export function MultiCustomerFlag({ isMultiCustomer }: { isMultiCustomer: boolean | undefined }) {
  if (!isMultiCustomer) return null
  return (
    <Tooltip title='Multi-Customer Order'>
      <Tag color='var(--theme-color-2-dim)' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '22px', height: '18px', minWidth: '22px', paddingInline: 0, marginInlineEnd: 0  }}>
        <IconUsers style={{ color: 'var(--theme-color-2)' }} size={12} />
      </Tag>
    </Tooltip>
  )
}

type NewVersionAvailableFlagProps = {
  newVersionAvailable: boolean | undefined
  difference: string | undefined
  isPosted: boolean | undefined
}

export function NewVersionAvailableFlag({ newVersionAvailable, difference, isPosted }: NewVersionAvailableFlagProps) {
  if (!newVersionAvailable) return null
  const tag = (
    <Tag color='var(--theme-warning-dim)' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '22px', minWidth: '22px', height: '18px', paddingInline: 0, marginInlineEnd:0  }}>
      <IconRefreshAlert style={{ color: 'var(--theme-warning)' }} size={12} />
    </Tag>
  )
  if (isPosted) {
    return (
      <Popover
        content={
          <Vertical gap={8}>
            <Horizontal verticalCenter gap={4}>
              <Texto style={{ flex: 1 }}>New Version Available. </Texto>
              <Texto weight='bold'>({difference})</Texto>
            </Horizontal>
            <Texto>
              You can refresh the order to update the line items. Warning: Overrides will be lost upon recalculation.
            </Texto>
          </Vertical>
        }
        trigger='hover'
        placement='topRight'
      >
        {tag}
      </Popover>
    )
  }

  return <Tooltip title={`New version available since order was sent. (${difference})`}>{tag}</Tooltip>
}
